import styled from 'styled-components'
import { theme } from '@/client/components'
const { space, breakpoint, color } = theme

export const HeaderSection = styled.div`
  @media (min-width: ${breakpoint.lg2}) {
    display: flex;
    margin-bottom: ${space.xl5};

    & img {
      position: relative;
      top: -2.5rem;
    }
  }
`

export const Sections = styled.div`
  width: 100%;
`

export const TableHeader = styled.div`
  display: none;
  align-items: baseline;
  width: 100%;

  @media (min-width: ${breakpoint.xl}) {
    display: flex;
  }
`

export const ContentsWrapper = styled.div`
  display: flex;
  align-items: baseline;
  width: 100%;
  margin-bottom: ${space.md};

  @media (min-width: ${breakpoint.xl}) {
    display: block;
    margin-bottom: 0;
  }
`

export const TableContents = styled.div`
  width: 100%;

  @media (min-width: ${breakpoint.xl}) {
    display: flex;
  }
`

export const TextWrapper = styled.div`
  width: 100%;
  margin-right: ${space.lg};

  & p {
    line-height: 1.2;
  }

  @media (min-width: ${breakpoint.xl}) {
    width: 40%;
  }
`

export const ImageWrapper = styled.div`
  padding-right: ${space.xl};
`

export const Contents = styled.div`
  display: none;

  @media (min-width: ${breakpoint.xl}) {
    display: block;
  }
`

export const Container = styled.div`
  background-color: ${color.grayscale.lighter};
  padding-top: ${space.xl};
  margin-bottom: ${space.xl6};
`

export const ButtonWrapper = styled.div`
  margin-bottom: ${space.xl};
  display: flex;
  width: 100%;
  justify-content: center;

  .button {
    height: 1.8rem;
    border-radius: ${space.xl2};
    width: max-content;
  }

  .calculatorLink {
    display: flex;
    align-items: center;
  }

  @media (min-width: ${breakpoint.xl}) {
    display: block;
    margin: ${space.xl7} 0 ${space.lg};
  }

  @media (min-width: ${breakpoint.hd}) {
    display: block;
    margin: ${space.xl} 0 ${space.lg};
  }
`
export const Divider = styled.div`
  position: relative;
  height: 3px;
  background-color: ${color.grayscale.headerGray};
  width: 100%;
  margin-bottom: ${space.lg};

  @media (min-width: ${breakpoint.xl}) {
    top: -2.4rem;
    left: 23.45rem;
    width: 70%;
    height: 2px;
  }
`

export const SmallScreenContent = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: ${space.sm};

  @media (min-width: ${breakpoint.md}) {
    grid-template-columns: ${space.xl9} 1fr;
  }

  @media (min-width: ${breakpoint.xl}) {
    display: none;
  }
`

export const SmallScreenContentWrapper = styled.div`
  margin-top: ${space.xl3};

  @media (min-width: ${breakpoint.xl}) {
    display: none;
  }
`
